import React from 'react'
import Layout from '../../../component/layout/Layout'
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const AutomaticMovingDieRheometer = () => {
    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 1000
    };

    const images = [
        'https://firebasestorage.googleapis.com/v0/b/rmcpl-8a920.appspot.com/o/upload%2FrubberPolymerIndustries%2F5.png?alt=media&token=0a4035ff-6b75-48c9-918d-63b2b1e26a5e',
        'https://firebasestorage.googleapis.com/v0/b/rmcpl-8a920.appspot.com/o/upload%2FrubberPolymerIndustries%2F5.png?alt=media&token=0a4035ff-6b75-48c9-918d-63b2b1e26a5e'
    ];

    return (
        <Layout>
            {/* Breadcrumb */}
            <div className="bread">
                <ul className="collapsed">
                    <li><a href="/">Home</a></li>
                    <li><a href="/rubber-polymer-industries">Rubber & Polymer Industries</a></li>
                </ul>
            </div>

            {/* Title */}
            <div className="container">
                <div className="section-title text-center" style={{ marginBottom: '2rem' }}>
                    <h1>Automatic Moving Die Rheometer</h1>
                </div>
            </div>

            {/* Main Section */}
            <section
                id="portfolio-details"
                className="portfolio-details"
                style={{ backgroundColor: 'white', marginBottom: '12rem' }}
            >
                <div className="container">
                    <div className="row gy-4">

                        {/* Image Slider */}
                        <div className="col-lg-8">
                            <div className="portfolio-details-slider swiper">
                                <Slider {...settings}>
                                    {images.map((src, index) => (
                                        <div className="swiper-slide" key={index}>
                                            <div className="img" style={{ alignItems: 'center' }}>
                                                <img src={src} alt="DIN Abrasion Tester" className="responsive" />
                                            </div>
                                        </div>
                                    ))}
                                </Slider>
                                <div className="swiper-pagination"></div>
                            </div>
                        </div>

                        {/* Description */}
                        <div className="col-lg-4">
                            <div className="portfolio-info" style={{ backgroundColor: 'white' }}>
                                <h3 className='pageheading'>Automatic Moving Die Rheometer</h3>
                                <p className='descriptionHead' style={{ textAlign: 'justify' }}>
                                    The Vluchem’ s AMR -10, Automatic Moving Die Rheometer is a reliable, accurate and easy to
                                    Operate Rheometer suit for routine and standards testing of rubber curing.
                                    AMR-10 operates continuous unattended operator with automatic sample feeding device and
                                    save operators time, his energy and avoid any risk factors.
                                    The AMR-10 uses sealed biconical dies meeting all relevant ASTM and ISO standards.
                                    The Vluchem’s AMR-10 is excellent to operate the stage for QC and R&amp;D circumstances
                                    Standards the instrument complies with: ASTM D 5289 ISO 6502

                                    <br /><br />
                                    <a
                                        href="mailto:inst@rmc.in?subject=Inquiry about Automatic Moving Die Rheometer"
                                        style={{
                                            color: '#0d6efd',
                                            fontWeight: '600',
                                            textDecoration: 'underline'
                                        }}
                                    >
                                        More Info
                                    </a>
                                </p>
                            </div>
                            <div className="portfolio-description"></div>
                        </div>

                    </div>
                </div>
            </section>

            <br />
        </Layout>
    )
}

export default AutomaticMovingDieRheometer